import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHoriz from "@mui/icons-material/MoreHoriz";

/**
 * MemberMenu
 * 各メンバー行に表示される 3点メニューコンポーネント。
 * 「スキルシート」「編集」「削除」のアクションをまとめて提供する。
 */

export default function MemberMenu({
  user,
  currentCompanyUser,
  onDetail,
  onEdit,
  onDelete,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  // Menu が開いているかどうか
  const open = Boolean(anchorEl);

  // 権限判定（統一）
  const isAdmin = currentCompanyUser?.role === "admin";
  const isGeneral = currentCompanyUser?.role === "general";
  const isManagerOfTargetUser = user.manager_id === currentCompanyUser?.id;

  const canEditUser = isAdmin || (isGeneral && isManagerOfTargetUser);
  const canDeleteUser = isAdmin;

  return (
    <>
      {/* 3点ボタン */}
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreHoriz fontSize="small" />
      </IconButton>

      {/* ドロップダウンメニュー */}
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {/* スキルシート詳細メニュー */}
        <MenuItem
          onClick={() => {
            onDetail(user);
            setAnchorEl(null);
          }}
        >
          スキルシートを見る
        </MenuItem>

        {/* 編集：権限があるユーザーのみ */}
        {canEditUser && (
          <MenuItem
            onClick={() => {
              onEdit(user);
              setAnchorEl(null);
            }}
          >
            メンバー情報を編集する
          </MenuItem>
        )}

        {/* 削除：管理者のみ */}
        {canDeleteUser && (
          <MenuItem
            onClick={() => {
              onDelete(user);
              setAnchorEl(null);
            }}
            sx={{ color: "error.main" }}
          >
            メンバーを削除する
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
